import IcFavoriteSVG from './IcFavoriteSVG'
export default IcFavoriteSVG
